<template>
    <el-dialog
            :visible.sync="visible"
            :width="width||'50%'"
            :before-close="hide"
            v-bind="modalProps">
        <component :is="com" ref="viewContent" v-bind="comProps">
        </component>
        <span slot="footer" class="dialog-footer" v-show="modalProps && !modalProps.hideFooter">
           <el-button @click="onCancel">取消</el-button>
           <el-button type="primary" @click="onOk">确定</el-button>
      </span>
    </el-dialog>
</template>

<script>
export default {
  name: 'TEST',
  data () {
    return {
      visible: false,
      com: null,
      modalProps: null,
      comProps: null,
      showResolve: null,
      showReject: null,
      width:"50%",
    }
  },
  computed: {},
  mounted () {
  },
  methods: {
    show (options = {}) {
      this.showResolve = null
      this.showReject = null
      return new Promise((resolve, reject) => {
        // 强制reset
        this.showResolve = resolve
        this.showReject = reject
        this.width=options.width||"50%"
        this.com = null
        this.comProps = {}
        this.comProps.hideModal = this.hide
        this.comProps.okModal = this.onOk
        if (options.modalProps) {
          this.modalProps = options.modalProps
        }
        if (options.comProps) {
          this.comProps = {
            ...this.comProps,
            ...options.comProps
          }
        }
        if (options.com) {
          this.$nextTick(() => {
            this.com = options.com
          })
        }
        this.visible = true
      })
    },
    hide () {
      this.visible = false
    },
    // 通用
    // ok -> 接口请求 -> 关闭
    // ok -> 传出参数 -> 关闭
    async onOk() {
      try {
        // 执行组件回调
        const viewContent = this.$refs.viewContent;
        const res = viewContent && viewContent.onOk ? await viewContent.onOk() : {};

        if (this.showResolve) {
          const result = {
            comResult: res
          };
          // 使用 ES5 写法判断 modalProps
          if (this.modalProps && this.modalProps.controlHide) {
            result.hide = this.hide;
          }
          this.showResolve(result);
        }

        if (!this.modalProps || !this.modalProps.controlHide) {
          this.hide();
        }
      } catch (err) {
        console.error('Modal operation failed:', err);
        // 校验失败：不关闭弹窗，也不 reject，让调用方的 await 保持等待
        if (err && err.message === 'VALIDATION') {
          return;
        }
        // 其他异常：正常 reject 给调用方处理
        if (this.showReject) {
          this.showReject(err);
        }
      } finally {
      }
    },
    async onCancel () {
      this.showReject && this.showReject()
      this.hide()
    }
  }
  // created() {
  //   this.$root.__viewModal = this
  // },
}
</script>

<style scoped lang="scss">
    .TEST {

    }
    .dialog-footer {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      letter-spacing: 0; // 去除文字间距
    }
    .dialog-footer :global(.el-button + .el-button) {
      margin-left: 12px; // 按钮间距
    }
</style>



// WEBPACK FOOTER //
// src/utils/plugins/zModel/ViewModal.vue